export const chatData = {
  about: `
    <p class="text-sm">Alex has had an interesting journey - building websites since he was 12, and has also worked at a few places! 🚀🚀</p>
    <p class="text-sm mt-2">Here's the full list:</p>
    <div id="job-carousel-container"></div>
  `,

  jobData: [
    {
      company: "Qualcomm",
      role: "Software Development Engineer",

      logo: "/images/Qualcomm-Logo.png",
      description:
        "Coding in python, automated test infra for Qualcomm. Made some useful tools.",
    },
    {
      company: "Bank of America Merrill Lynch",
      role: "Global Markets",

      logo: "images/BAML_logo.jpg",
      description: "Building & Selling in a Big Bank (Product & CS), Equities.",
    },
    {
      company: "HSBC Ventures",
      role: "Venture Capital",

      logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/aa/HSBC_logo_%282018%29.svg/1200px-HSBC_logo_%282018%29.svg.png",
      description:
        "Giving (admittedly very cool) people over $100m to build, scale (& invest).",
    },
    {
      company: "PerfectDraft (ZX Ventures)",
      role: "Product & Operations",

      logo: "/images/pd.png",
      description:
        "Built a pilot for a secondary marketplace in 10 weeks - inclu. website, marketing, warehouse & ops setup. Was scaled into Production post-launch, still Live.",
    },
    {
      company: "Nomura",
      role: "M&A",

      logo: "/images/Nomura-Logo.jpg",
      description: "Excel and PPTs.",
    },
  ],

  philosophy: `
    <p class="text-sm">Alex has a curious mind and loves learning by doing. If you have any interesting ideas - he'd love to chat!💡</p>

    <p class="text-sm mt-2">Also, a fun fact: Alex is aiming to visit all countries in the world! 🌍</p>
  `,

  investments: `
    <p class="text-sm">Here are some of Alex's investments:</p>
    
    <div id="investments-container" class="mt-3"></div>
  `,

  projects: `
    <p class="text-sm">Alex has built a few projects over the years! Here are some of his key projects (some successes and failures):</p>
    
    <div class="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-3">
      <div class="project-card bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 overflow-hidden group hover:shadow-md transition-all">
        <div class="p-3 relative overflow-hidden">
          <div class="flex justify-between items-center">
            <h3 class="text-sm font-medium group-hover:text-blue-600 dark:group-hover:text-blue-400 transition-all">Inspirizone</h3>
            <div class="flex items-center space-x-1">
              <span class="text-xs px-2 py-0.5 rounded-full bg-yellow-50 text-yellow-600 dark:bg-yellow-900 dark:text-yellow-200 flex items-center">
                <span class="mr-1">PH</span>
                <span class="font-bold">#1</span>
              </span>
              <span class="text-xs px-2 py-0.5 rounded-full bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200">Sold</span>
            </div>
          </div>
          <div class="mt-1 text-xs text-gray-600 dark:text-gray-300 h-0 group-hover:h-auto opacity-0 group-hover:opacity-100 transition-all duration-300 overflow-hidden">
            Curated design inspiration marketplace. Ranked #1 Product of Day on ProductHunt. 🏆
      
          </div>
        </div>
      </div>

      <div class="project-card bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 overflow-hidden group hover:shadow-md transition-all">
        <div class="p-3 relative overflow-hidden">
          <div class="flex justify-between items-center">
            <h3 class="text-sm font-medium group-hover:text-blue-600 dark:group-hover:text-blue-400 transition-all">UIPalette</h3>
            <div class="flex items-center space-x-1">
              <span class="text-xs px-2 py-0.5 rounded-full bg-red-50 text-red-600 dark:bg-red-900 dark:text-red-200 flex items-center">
                <span class="mr-1">PH</span>
                <span class="font-bold">#3</span>
              </span>
              <span class="text-xs px-2 py-0.5 rounded-full bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200">Inactive</span>
            </div>
          </div>
          <div class="mt-1 text-xs text-gray-600 dark:text-gray-300 h-0 group-hover:h-auto opacity-0 group-hover:opacity-100 transition-all duration-300 overflow-hidden">
            Collation of all design trends and colors. Ranked #3 Product of Day on ProductHunt. 🏆
            
          </div>
        </div>
      </div>
      
      <div class="project-card bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 overflow-hidden group hover:shadow-md transition-all">
        <div class="p-3 relative overflow-hidden">
          <div class="flex justify-between items-center">
            <h3 class="text-sm font-medium group-hover:text-blue-600 dark:group-hover:text-blue-400 transition-all">Designr Co</h3>
            <span class="text-xs px-2 py-0.5 rounded-full bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200">Live</span>
          </div>
          <div class="mt-1 text-xs text-gray-600 dark:text-gray-300 h-0 group-hover:h-auto opacity-0 group-hover:opacity-100 transition-all duration-300 overflow-hidden">
            Building websites for local businesses (via classified ads platforms, others), and top-rated seller on Fiverr. Also built themes and templates on themeforest.
            <div class="mt-2">
              <a href="mailto:alex@designr.co" target="_blank" class="text-blue-600 dark:text-blue-400 hover:underline inline-flex items-center text-xs">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                </svg>
                Email me now!
              </a>
            </div>
          </div>
         
        </div>
      </div>
      
      <div class="project-card bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 overflow-hidden group hover:shadow-md transition-all">
        <div class="p-3 relative overflow-hidden">
          <div class="flex justify-between items-center">
            <h3 class="text-sm font-medium group-hover:text-blue-600 dark:group-hover:text-blue-400 transition-all">MyMovieFinder</h3>
            <span class="text-xs px-2 py-0.5 rounded-full bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200">Live</span>
          </div>
          <div class="mt-1 text-xs text-gray-600 dark:text-gray-300 h-0 group-hover:h-auto opacity-0 group-hover:opacity-100 transition-all duration-300 overflow-hidden">
            A movie suggestion website. My first collaboration – did front-end, back-end in PHP (Laravel).
            <div class="mt-2">
              <a href="https://mymoviefinder.com/" target="_blank" class="text-blue-600 dark:text-blue-400 hover:underline inline-flex items-center text-xs">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                </svg>
                Visit website
              </a>
            </div>
          </div>
        </div>
      </div>
      
      <div class="project-card bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 overflow-hidden group hover:shadow-md transition-all">
        <div class="p-3 relative overflow-hidden">
          <div class="flex justify-between items-center">
            <h3 class="text-sm font-medium group-hover:text-blue-600 dark:group-hover:text-blue-400 transition-all">BuyGecko</h3>
            <span class="text-xs px-2 py-0.5 rounded-full bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200">Sold / Traded</span>
          </div>
          <div class="mt-1 text-xs text-gray-600 dark:text-gray-300 h-0 group-hover:h-auto opacity-0 group-hover:opacity-100 transition-all duration-300 overflow-hidden">
            Viral goods for your phone, delivered straight to your door. Scaled to $1k/day using organic marketing only (IG).
          </div>
        </div>
      </div>
      
      <div class="project-card bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 overflow-hidden group hover:shadow-md transition-all">
        <div class="p-3 relative overflow-hidden">
          <div class="flex justify-between items-center">
            <h3 class="text-sm font-medium group-hover:text-blue-600 dark:group-hover:text-blue-400 transition-all">ElephantForest</h3>
            <span class="text-xs px-2 py-0.5 rounded-full bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200">Inactive</span>
          </div>
          <div class="mt-1 text-xs text-gray-600 dark:text-gray-300 h-0 group-hover:h-auto opacity-0 group-hover:opacity-100 transition-all duration-300 overflow-hidden">
            Elephant-related goods, delivered to your door. Donating to DSWT. Built a 25k+ following. Grew other IG and twitter accounts using organic techniques.
          </div>
         
        </div>
      </div>
      
      <div class="project-card bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 overflow-hidden group hover:shadow-md transition-all">
        <div class="p-3 relative overflow-hidden">
          <div class="flex justify-between items-center">
            <h3 class="text-sm font-medium group-hover:text-blue-600 dark:group-hover:text-blue-400 transition-all">Twitter Bot</h3>
            <span class="text-xs px-2 py-0.5 rounded-full bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200">Inactive</span>
          </div>
          <div class="mt-1 text-xs text-gray-600 dark:text-gray-300 h-0 group-hover:h-auto opacity-0 group-hover:opacity-100 transition-all duration-300 overflow-hidden">
            Built a twitter bot with python to auto-engage users, driving revenues to my e-commerce stores.
          </div>
        </div>
      </div>
      
      <div class="project-card bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 overflow-hidden group hover:shadow-md transition-all">
        <div class="p-3 relative overflow-hidden">
          <div class="flex justify-between items-center">
            <h3 class="text-sm font-medium group-hover:text-blue-600 dark:group-hover:text-blue-400 transition-all">Acceler8</h3>
            <span class="text-xs px-2 py-0.5 rounded-full bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200">Live</span>
          </div>
          <div class="mt-1 text-xs text-gray-600 dark:text-gray-300 h-0 group-hover:h-auto opacity-0 group-hover:opacity-100 transition-all duration-300 overflow-hidden">
            Start-up Accelerator for University of Bath students. Backed by Santander. Still running today.
            <div class="mt-2">
              <a href="https://www.linkedin.com/company/acceler8bybe/" target="_blank" class="text-blue-600 dark:text-blue-400 hover:underline inline-flex items-center text-xs">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                </svg>
                Visit website
              </a>
            </div>
          </div>
        </div>
      </div>
      
      <div class="project-card bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 overflow-hidden group hover:shadow-md transition-all">
        <div class="p-3 relative overflow-hidden">
          <div class="flex justify-between items-center">
            <h3 class="text-sm font-medium group-hover:text-blue-600 dark:group-hover:text-blue-400 transition-all">Perfect Draft Secondary Marketplace</h3>
            <span class="text-xs px-2 py-0.5 rounded-full bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200">Live</span>
          </div>
          <div class="mt-1 text-xs text-gray-600 dark:text-gray-300 h-0 group-hover:h-auto opacity-0 group-hover:opacity-100 transition-all duration-300 overflow-hidden">
            Sell your machine, or buy a refurbished machine. Built a pilot end-to-end. 50 clients in 1 week. Scaled to production post.
            <div class="mt-2">
              <a href="https://www.perfectdraft.com/en-gb/perfectdraft-machine-refurbished" target="_blank" class="text-blue-600 dark:text-blue-400 hover:underline inline-flex items-center text-xs">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                </svg>
                Visit website
              </a>
            </div>
          </div>
        </div>
      </div>
      
      <div class="project-card bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 overflow-hidden group hover:shadow-md transition-all">
        <div class="p-3 relative overflow-hidden">
          <div class="flex justify-between items-center">
            <h3 class="text-sm font-medium group-hover:text-blue-600 dark:group-hover:text-blue-400 transition-all">TheGiftHut</h3>
            <span class="text-xs px-2 py-0.5 rounded-full bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200">Inactive</span>
          </div>
          <div class="mt-1 text-xs text-gray-600 dark:text-gray-300 h-0 group-hover:h-auto opacity-0 group-hover:opacity-100 transition-all duration-300 overflow-hidden">
            Find the gift you want for your loved ones. An affiliate gifting site targeting seasonal occasions and personalized to your person.
          </div>
        </div>
      </div>
      
      <div class="project-card bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 overflow-hidden group hover:shadow-md transition-all">
        <div class="p-3 relative overflow-hidden">
          <div class="flex justify-between items-center">
            <h3 class="text-sm font-medium group-hover:text-blue-600 dark:group-hover:text-blue-400 transition-all">Pessimistic Penguinz</h3>
            <span class="text-xs px-2 py-0.5 rounded-full bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200">Inactive</span>
          </div>
          <div class="mt-1 text-xs text-gray-600 dark:text-gray-300 h-0 group-hover:h-auto opacity-0 group-hover:opacity-100 transition-all duration-300 overflow-hidden">
            An NFT collection based on polygon, to fund the fight against climate change.
          </div>
        </div>
      </div>
      
      <div class="project-card bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 overflow-hidden group hover:shadow-md transition-all">
        <div class="p-3 relative overflow-hidden">
          <div class="flex justify-between items-center">
            <h3 class="text-sm font-medium group-hover:text-blue-600 dark:group-hover:text-blue-400 transition-all">Startupandoperators.com</h3>
            <span class="text-xs px-2 py-0.5 rounded-full bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200">Live</span>
          </div>
          <div class="mt-1 text-xs text-gray-600 dark:text-gray-300 h-0 group-hover:h-auto opacity-0 group-hover:opacity-100 transition-all duration-300 overflow-hidden">
            Curated Tier 1 VC backed jobs, for the doers.
            <div class="mt-2">
              <a href="https://startupandoperators.com" target="_blank" class="text-blue-600 dark:text-blue-400 hover:underline inline-flex items-center text-xs">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                </svg>
                Visit website
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,

  ramblings: `
    <p class="text-sm">Alex shares his thoughts and insights on various topics. You can find his latest writings here:</p>
    
    <div class="mt-3 space-y-3">
      <a href="https://x.com/alstras" target="_blank" class="flex items-center text-blue-600 dark:text-blue-400 hover:underline">
        <svg class="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 24 24">
          <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
        </svg>
        Follow on X
      </a>
      
      <a href="https://medium.com/@alexsaundersofc" target="_blank" class="flex items-center text-blue-600 dark:text-blue-400 hover:underline">
        <svg class="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 24 24">
          <path d="M13.54 12a6.8 6.8 0 01-6.77 6.82A6.8 6.8 0 010 12a6.8 6.8 0 016.77-6.82A6.8 6.8 0 0113.54 12zm7.42 0c0 3.54-1.51 6.42-3.38 6.42-1.87 0-3.39-2.88-3.39-6.42s1.52-6.42 3.39-6.42 3.38 2.88 3.38 6.42M24 12c0 3.17-.53 5.75-1.19 5.75-.66 0-1.19-2.58-1.19-5.75s.53-5.75 1.19-5.75C23.47 6.25 24 8.83 24 12z"/>
        </svg>
        Read on Medium
      </a>
    </div>
  `,
  
  ramblingData: [], // Empty array since we're not using native posts anymore
};
